import * as Tabs from "@radix-ui/react-tabs";
import styled from "@emotion/styled";

export * from "@radix-ui/react-tabs";

export const Trigger = styled(Tabs.Trigger)`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  border-bottom: 3px solid transparent;
  padding: 0 12px;
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.forest};
  }
  &:hover {
    background: rgba(34, 34, 34, 0.1);
  }
  &[data-state="active"] {
    color: ${({ theme }) => theme.colors.charcoal};
    border-bottom: 3px solid ${({ theme }) => theme.colors.charcoal};
    font-weight: 800;
  }
  cursor: pointer;
`;

export const Content = styled(Tabs.Content)`
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.forest};
    outline-offset: 4px;
  }
`;

export const List = styled(Tabs.List)`
  flex-shrink: 0;
  display: flex;
  border-bottom: 2px solid ${(props) => props.theme.colors.mist};
`;
